// Redux Import
import { configureStore } from '@reduxjs/toolkit';

// Middleware Imports
import { slices } from './app/slice';
import { ErrorHandler } from './middleware/error';
import { SuccessHandler } from './middleware/success';

// Reducers Imports
import users from './slices/users';
import questions from './slices/questions';
import quizResponse from './slices/quizResponse';
import quizTemplate from './slices/quizTemplate';
import adminQuiz from './slices/adminQuiz';
import taxFiles from './slices/taxFiles';
import documents from './slices/documents';
import versions from './slices/versions';
import announcement from './slices/announcement';
import notification from './slices/notifications';

const store = configureStore({
  reducer: {
    users,
    questions,
    quizResponse,
    quizTemplate,
    adminQuiz,
    taxFiles,
    documents,
    versions,
    announcement,
    notification,
    [slices.reducerPath]: slices.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(slices.middleware)
      .concat(ErrorHandler)
      .concat(SuccessHandler),
});

export default store;
